import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { supabase } from "@/hooks/useSupabase";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    const cleanEmail = email.trim().toLowerCase();
    if (!cleanEmail || !password) {
      setError("Preencha e-mail e senha.");
      return;
    }
    setLoading(true);
    try {
      const { data: signInData, error: signInError } = await supabase.auth.signInWithPassword({
        email: cleanEmail,
        password: password,
      });
      if (signInError) {
        setError("Erro: " + signInError.message);
        setLoading(false);
        return;
      }
      if (!signInData?.user) {
        setError("Erro inesperado.");
        setLoading(false);
        return;
      }
      // Verificar se é admin
      const { data: profile } = await supabase
        .from("user_profiles")
        .select("role")
        .eq("id", signInData.user.id)
        .maybeSingle();
      if (profile?.role !== "admin") {
        setError("Acesso negado.");
        setLoading(false);
        return;
      }
      // Login ok, redirecionar
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError("Erro ao conectar. Tente novamente.");
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    const cleanEmail = email.trim().toLowerCase();
    if (!cleanEmail) {
      setError("Informe seu e-mail.");
      return;
    }
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(cleanEmail, {
      redirectTo: `${window.location.origin}/admin/login`,
    });
    if (error) {
      setError("Erro ao enviar recuperação.");
    } else {
      setError("E-mail de recuperação enviado!");
    }
    setLoading(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-sm border border-gray-100">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Portal Admin</h1>
          <p className="text-sm text-gray-500">Acesse o painel administrativo</p>
        </div>

        <div className="mb-4 p-3 bg-amber-50 rounded-md border border-amber-200 text-sm text-amber-800">
          <p className="font-semibold">E-mail cadastrado:</p>
          <p className="font-bold">2000lojacm@gmail.com</p>
          <p className="text-xs mt-1 text-amber-600">Use este e-mail para entrar</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">E-mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(""); }}
              className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500"
              placeholder="seu@email.com"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Senha</label>
            <input
              type="password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(""); }}
              className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500"
              placeholder="Sua senha"
            />
          </div>
          {error && (
            <div className="p-3 bg-red-50 text-red-700 text-sm rounded-md border border-red-100">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 bg-gray-900 text-white text-sm font-medium rounded-md hover:bg-gray-800 transition-colors disabled:opacity-50 cursor-pointer whitespace-nowrap"
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
          <div className="flex items-center justify-between text-sm">
            <button
              type="button"
              onClick={handleForgotPassword}
              disabled={loading}
              className="text-amber-600 hover:text-amber-700 cursor-pointer disabled:opacity-50"
            >
              Esqueci minha senha
            </button>
            <Link to="/" className="text-gray-500 hover:text-gray-700">
              Voltar ao portal
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}